import { IJsonQueryCircle } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoCircleTagsManager = createGeoTagsManager<IJsonQueryCircle>({
  jsonQueryKey: 'distance',
  id: 'geoCircle',
  labelGetter: ({ geoValue }) => geoValue.name,
});
